import iconGitHub from "images/icon-github.svg"
import iconTwitter from "images/icon-twitter.svg"
import iconDiscord from "images/icon-discord.svg"
import iconDocuments from "images/icon-docs.svg"

import iconGitHubLight from "images/icon-github-primary.svg"
import iconTwitterLight from "images/icon-twitter-primary.svg"
import iconDiscordLight from "images/icon-discord-primary.svg"
import iconDocumentsLight from "images/icon-docs-primary.svg"

/* terra:network */
//export const FINDER = "https://finder.terraclassic.community/mainnet"
export const FINDER = "https://finder.terraclassic.community/mainnet"
export const TERRA_STATION_EXTENSION =
  "https://chrome.google.com/webstore/detail/terra-station/aiifbnbfobpmeekipheeijimdpnlpgpp"
export const XDEFI_EXTENSION =
  "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf"
export const CHROME = "https://google.com/chrome"

// Standard CW20 Info
export const CW20_NAME = "uLP"
export const CW20_SYMBOL = "uLP"
export const CW20_ADDR =
  "terra1w46kanfv5uxetdhmux63av2r5hh3p3f97fvrdx8c2xf6lgd97sfss6nf66"
export const CW20_ICON = "https://i.ibb.co/Y0Jk49R/coin-u-LP-128.png"
export const CW20_WEBSITE = ""
export const WHITE_PAPER_URL = ""
// Staking Specific
export const MANAGER = "terra183yjyennklj77uc47txds9mmpu6vlaecaxk66g"
export const CONSULTANT = "terra12wfuxr6yud2zxxxy95pq5satwy6pzfah3zcumq"
export const ARBITER_ADDRESS = "terra183yjyennklj77uc47txds9mmpu6vlaecaxk66g"
export const STAKE_FACTORY_ADDR =
  "terra17ap7ytq0ztnhs5x4wk2p8m6lm9lffayufz0z6f4hl4q6uag6p2mqldtjwn"
export const STAKING_ADDR =
  "terra1j5rwsrp2zzkq242aag5xlpdduetc0aqlv849y05u7mtuu4gxy6ss2mlpju"

/* terra:configs */
export const BLOCK_TIME = 6650 // 6.65s

/* coin:unit */
export const MIR = "MIR"
export const UUSD = "uusd"
export const ULUNA = "uluna"
export const UKRW = "ukrw"
export const USDR = "usdr"
export const UMNT = "umnt"
export const UAUD = "uaud"
export const UCAD = "ucad"
export const UCHF = "uchf"
export const UCNY = "ucny"
export const UEUR = "ueur"
export const UGBP = "ugbp"
export const UHKD = "uhkd"
export const UINR = "uinr"
export const UJPY = "ujpy"
export const USGD = "usgd"
export const UTHB = "uthb"
export const UST = "UST"
export const KRT = "KRT"
export const SDT = "SDT"
export const MNT = "MNT"
export const LUNA = "uluna"
export const AUT = "AUT"
export const CAT = "CAT"
export const CHT = "CHT"
export const CNT = "CNT"
export const EUT = "EUT"
export const GBT = "GBT"
export const HKT = "HKT"
export const INT = "INT"
export const JPT = "JPT"
export const SGT = "SGT"
export const THT = "THT"
export const LP = "LP"

export const NATIVE_TOKENS = [
  ULUNA,
  UUSD,
  UKRW,
  USDR,
  UMNT,
  UEUR,
  UCNY,
  UJPY,
  UGBP,
  UINR,
  UCAD,
  UCHF,
  UAUD,
  USGD,
  UTHB,
  UHKD,
]

/* dApp configs */
export const DEFAULT_MAX_SPREAD = 0.5
export const MAX_MSG_LENGTH = 1024

/* network:settings */
export const TX_POLLING_INTERVAL = 1000
export const MAX_TX_POLLING_RETRY = 35
export const DEFAULT_EXT_NETWORK: ExtNetworkConfig = {
  name: "mainnet",
  chainID: "columbus-5",
  fcd: "https://terra-classic-fcd.publicnode.com",
  lcd: "https://terra-classic-lcd.publicnode.com",
}

/* project */
export const MEDIUM = ""
export const DISCORD = ""
export const TELEGRAM = ""
export const WECHAT = ""
export const GITHUB = ""

export const socialMediaList = [
  {
    icon: iconGitHub,
    iconLight: iconGitHubLight,
    href: "",
    title: "GitHub",
  },
  {
    icon: iconTwitter,
    iconLight: iconTwitterLight,
    href: "https://twitter.com/jaylea1989",
    title: "Twitter",
  },
  {
    icon: iconDiscord,
    iconLight: iconDiscordLight,
    href: "",
    title: "Discord",
  },
  {
    icon: iconDocuments,
    iconLight: iconDocumentsLight,
    href: "justjasoncrypto.wixsite.com/mysite",
    title: "Documents",
  },
]
